import { Link, useLocation } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export function NotFoundPage() {
  const location = useLocation()

  return (
    <div className="flex flex-col items-center justify-center py-16">
      <h1 className="text-6xl font-bold text-gray-300">404</h1>
      <h2 className="mt-4 text-xl font-semibold text-gray-900">Page not found</h2>
      <p className="mt-2 text-sm text-gray-500">
        The page{' '}
        <code className="rounded bg-gray-100 px-1.5 py-0.5 text-xs">{location.pathname}</code>{' '}
        doesn't exist.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-2 rounded-lg bg-zero-600 px-4 py-2 text-sm font-medium text-white hover:bg-zero-700"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to home
      </Link>
    </div>
  )
}
